module.exports = __webpack_public_path__ + "img/bg2.8fbc9ff2.jpg";